export const enum TaskRecurrencyPeriodToggle {
    Infinite = "infinite",
    Period = "period"
}


// WEBPACK FOOTER //
// ./src/Models/Tasks/TaskRecurrencies/TaskRecurrencyPeriodToggle.ts